"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const core_1 = require("@material-ui/core");
const Select = styled_components_1.default(core_1.Select) `
  padding: 10px;
  border-style: solid;
  border-width: 1px;
  border-radius: 4px;
  border-color: rgba(0, 0, 0, 0.23);
  margin-top: 5px;
  height: 56px;
`;
exports.default = Select;
//# sourceMappingURL=index.js.map